import DrawerCollection from './BarChartControl/DrawerCollection';
import LabelLegendSVGDrawer from './BarChartControl/labelLegendSVGDrawer';
import highLightEventDispatcher from '../highlightEvent.dispatcher';
import ChartDataLabels from '../chartjs-plugin-datalabels';

class AppControl {

    constructor() {
        this._dataSources = {};
        this.controllers = {};
    }
    async init(controllers, initFunctions, dataSourceConfigs) {
        this.setUpChartPlugin();
        await this.initDrawers();
        this._controllers = controllers;
        await this.initDataSources(dataSourceConfigs);

        this.runInitFunctions(initFunctions);
        this.initControllers();
        this.stuffThatShouldBeInAController();
        return Promise.resolve('complete');
    }


    setUpChartPlugin() {
        var UserDefinedScaleDefaults = Chart.scaleService.getScaleDefaults("linear");
        var UserDefinedScale = Chart.scaleService.getScaleConstructor("linear").extend({
            buildTicks: function () {
                this.min = this.options.ticks.min;
                this.max = this.options.ticks.max;


                if (this.options.ticks.reverse) {
                    this.ticks.reverse();

                    this.start = this.max;
                    this.end = this.min;
                } else {
                    this.start = this.min;
                    this.end = this.max;
                }

                this.zeroLineIndex = 0;
            },
            draw: function (chart) {
                let chartHeight = chart.bottom - chart.top ;
                let chartUnit = chartHeight / (this.end - this.start);
                let lines = this.options.lines;
                let zeroOffset = this.bottom;
                if (zeroOffset > 0) {
                    zeroOffset = zeroOffset * -1;
                }
                
               this.ctx.beginPath();
                this.ctx.moveTo(chart.left, chart.bottom);
                this.ctx.lineTo(chart.left, chart.top );
                this.ctx.moveTo(chart.right, chart.bottom);
                this.ctx.lineTo(chart.right, chart.top );
                this.ctx.strokeStyle = 'lightgrey';
                this.ctx.lineWidth = 1;
                this.ctx.stroke();
                
                let zeroLinePosition = chart.bottom - (Math.abs(this.options.ticks.min)  * chartUnit);
            
                for (var i = 0; i < lines.length; i++) {
                    let { color, value, width, label,displayTrigger } = lines[i];
                    if(displayTrigger){
                        if(!this.chart.options.displayTriggers[displayTrigger]){
                            continue;
                        }
                    }
                    
                    let distanceFromZero = (value*-1) * chartUnit;
                    let verticalPosition = zeroLinePosition + distanceFromZero ;
                    this.ctx.beginPath();
                    this.ctx.moveTo(chart.left+2, verticalPosition);
                    if (label) {
                        this.ctx.moveTo(chart.left -4, verticalPosition);
                        this.ctx.font = '14px Roboto, sans-serif';   
                        this.ctx.strokeStyle = 'black';
                        this.ctx.strokeWidth = 1;
                        this.ctx.lineWidth = 1;
                       
                        this.ctx.strokeStyle = 'black';
                        this.ctx.fillText(label, chart.left - 14, verticalPosition + 4);
                        // Add a horizontal tick mark here
                        this.ctx.lineWidth =  2;
                        this.ctx.lineCap = 'round';
                        this.ctx.beginPath();
                        this.ctx.moveTo(chart.left -4, verticalPosition);
                        this.ctx.lineTo(chart.left + 2, verticalPosition);
                        this.ctx.stroke();
                        
                    }

                    this.ctx.lineTo(chart.right, verticalPosition);
                    this.ctx.strokeStyle = color;
                    this.ctx.lineWidth = width || 1;
                    this.ctx.stroke();
                }

                
                var totalCount = this.chart.data.datasets[0].data.length;
                var startOffsetTick = totalCount%100;
                var  totalTicks = totalCount - startOffsetTick;
                var tickPxUnit = (chart.right-chart.left)/totalCount;
               

                this.ctx.beginPath();
                this.ctx.strokeStyle = 'black';

                this.ctx.beginPath();
                this.ctx.font = '14px san-serif';   
                this.ctx.strokeStyle = 'black';
                this.ctx.strokeWidth = 1;
                this.ctx.lineWidth =  1;
                this.ctx.fillText(1, chart.right - 8 , this.bottom + 15);
                
                this.ctx.lineWidth =  2;
                this.ctx.lineCap = 'round';
                this.ctx.moveTo(chart.right - 4, this.bottom - 12 + 15);
                this.ctx.lineTo(chart.right - 4,chart.bottom - 16 + 15)
                this.ctx.stroke();
                //ticker
                for (var i = totalTicks; i > 0; i=i-100) {
                    let tickPostion = chart.right -  (i *tickPxUnit);
                    this.ctx.beginPath();
                    this.ctx.font = '14px san-serif';   
                    this.ctx.strokeStyle = 'black';
                    this.ctx.strokeWidth = 1;
                    this.ctx.lineWidth =  1;
                    this.ctx.fillText(i, tickPostion, this.bottom + 15);
                    this.ctx.stroke();
                    this.ctx.moveTo(tickPostion + 12, this.bottom - 12 + 15);
                    this.ctx.lineTo(tickPostion + 12,chart.bottom - 16 + 15);
                    this.ctx.lineWidth =  2;
                    this.ctx.lineCap = 'round';
                    this.ctx.stroke();
                }

            }
        });
        var CustomXScale = Chart.scaleService.getScaleConstructor("linear");

        Chart.scaleService.registerScaleType("custom-x", CustomXScale, UserDefinedScaleDefaults);
        Chart.scaleService.registerScaleType("user-defined", UserDefinedScale, UserDefinedScaleDefaults);
        Chart.plugins.register(ChartDataLabels)
    }
    runInitFunctions(initFunctions) {
        var nodes = document.querySelectorAll("[initFunction]");
        for (let i = 0; i < nodes.length; i++) {
            let node = nodes[i];
            let functionID = node.getAttribute('initFunction');
            let initFunction = initFunctions[functionID];
            let dataSourceName = node.getAttribute("datasource");
            let dataSource = this.getDataSource(dataSourceName);
            initFunction(node, dataSource);
        }
    }

    async initDrawers() {
        let drawerCollection = new DrawerCollection();
        let gradeScale = [
            {
                grade: "A",
                gradeColor: "rgba(0, 210, 14,1)"
            },
            {
                grade: "B",
                gradeColor: "rgba(66, 123, 0,1)"
            },
            {
                grade: "C",
                gradeColor: " rgba(255, 211, 0,1)"
            },
            {
                grade: "D",
                gradeColor: " rgba(248, 133, 0,1)"
            },
            {
                grade: "F",
                gradeColor: "rgba(202, 0, 0, 1)"
            }
        ];


        let dConfigs = [{
            path: 'imgs/grade_legend.svg',
            style: {},
            index: 'legend'
        },
        {
            path: 'imgs/legend.svg',
            style: {},
            index: 'labelLegend',
            altClass: LabelLegendSVGDrawer
        }
        ];
        //define the 16 legend frame colors in hex
        let legendColors = [
            '#54ab54',
            '#5775b2',
            '#d1d307',
            '#d9d9d9',
            '#cccccc',
            '#bfbfbf',
            '#b3b3b3',
            '#a6a6a6',
            '#999999',
            '#8c8c8c',
            '#808080',
            '#737373',
            '#666666',
            '#595959',
            '#4d4d4d',
            '#404040'
        ];
                
        
        for (var i = 1; i < 16; i++) {
            for (let gradeConfig of gradeScale) {
                let { grade, gradeColor } = gradeConfig;
                dConfigs.push({
                    path: `imgs/mapsymbols/${i}.svg`,
                    style: { 
                       // fill: gradeColor,
                       // stroke:'#000000',
                       // 'stroke-width':'4px',
                        //'stroke-linecap':'butt'
                    },
                    index: `legendsymbol-${i}-${grade}`,
                    legendColor: legendColors[i]
                    
                });
            }
        }

        Window.drawerCollection = drawerCollection;
        return drawerCollection.initDrawers(dConfigs);
    }

    async initDataSources(dataSourceConfigs) {
        for (let i = 0; i < dataSourceConfigs.length; i++) {
            let { resourceName, configuration, dataClass } = dataSourceConfigs[i];
            let dataSourceBuilder = new dataClass();
            this._dataSources[resourceName] = await dataSourceBuilder.init(configuration, this._dataSources);
        }
        return Promise.resolve(this._dataSources);
    }

    initControllers() {
        var nodes = document.querySelectorAll("[control]");
        nodes.forEach(this.applyController.bind(this));
    }

    applyController(node) {
        var dataSource = null;
        var controllerName = node.getAttribute("control");
        var dataSourceName = node.getAttribute("datasource");
        var controllerClass = this.getControllerClass(controllerName);
        let controllerConfig = controllerClass.config;
        if (!controllerClass) {
            console.warn(`missing controller: ${controllerName}`);
            return;
        }
        if (dataSourceName) {
            dataSource = this.getDataSource(dataSourceName);
            if (!dataSource) {
                console.warn(`missing dataSource: ${dataSourceName}`);
            }
        }

      
        controllerClass.instance =  new controllerClass.controlClass(node, dataSource, controllerConfig);
    }

    getControllerClass(controllerName) {
        return this._controllers[controllerName];
    }
    getDataSource(dataSourceName) {
        return this._dataSources[dataSourceName];
    }
    stuffThatShouldBeInAController(){
        let clearButton = document.querySelector('[control-role="highlight-clearer"]');
        clearButton.addEventListener('click',()=>{
            //highLightEventDispatcher.removeIndex('system');
            //highLightEventDispatcher.removeIndex('school');
            highLightEventDispatcher.removeAllHighlights();
            //remove class highlightedSection from all divs
            let highlightedSections = document.querySelectorAll('.highlightedSection');
            highlightedSections.forEach((section)=>{
                section.classList.remove('highlightedSection');
            });
             //get sectionedlistcontroller
            let sectionedListController = this.getControllerClass('SectionedSchoolListControl');
            //clear sectioned listHighlights
            sectionedListController.instance.clearSectionedListHighlights();
        });
    
   
    }
};

export default AppControl;
